import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatError } from "../lib/api";
import { AuthShell, Field } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/auth/forgot-password", { email });
      toast.success(res.data.message || "If that email exists, a reset link has been sent.");
      setSent(true);
    } catch (e) {
      toast.error(formatError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <AuthShell title="Check your inbox." subtitle="If an account exists for that email, we've sent a secure reset link.">
        <p className="text-sm text-[#A19DB0]" data-testid="forgot-sent-message">
          The link expires in 1 hour and can be used once. Be sure to check your spam folder.
        </p>
        <p className="text-center text-sm text-[#A19DB0] mt-6">
          <Link to="/login" className="text-[#D4AF37] font-medium" data-testid="back-login">Back to sign in</Link>
        </p>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Reset your password." subtitle="We'll email you a secure reset link.">
      <form onSubmit={submit}>
        <Field label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" placeholder="you@email.com" />
        <button disabled={busy} data-testid="forgot-submit" className="w-full mt-2 bg-[#D4AF37] text-black font-semibold rounded-full py-3.5 hover:bg-[#E5C158] active:scale-[0.98] transition-all disabled:opacity-60">
          {busy ? "Sending…" : "Send reset link"}
        </button>
      </form>
      <p className="text-center text-sm text-[#A19DB0] mt-5">
        <Link to="/login" className="text-[#D4AF37] font-medium" data-testid="back-login">Back to sign in</Link>
      </p>
    </AuthShell>
  );
}
